<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
    <p>{{ data.content }}</p>
</div>
<div mat-dialog-actions class="m-0" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="24px">
    <button mat-button (click)="matDialogRef.close(false)">{{ 'confirm_dialog.cancel' | translate }}</button>
    <button mat-flat-button color="accent"
        (click)="matDialogRef.close(true)">{{ 'confirm_dialog.confirm' | translate }}</button>
</div>